// FIXME: We are not importing via `~utils` due to a circular dependency
import { translate } from "utils/string-table";

import { CancelReasonKey, CancelReasonKeyType } from "./constants";

export const cancelReasons = {
  [CancelReasonKey.SubmitError]: translate("CANCEL_REQ_REASON_SUBMIT_ERROR"),
  [CancelReasonKey.FilledByAltSrc]: translate("CANCEL_REQ_REASON_FILLED_BY_ALT_SRC"),
  [CancelReasonKey.SubNotNeeded]: translate("CANCEL_REQ_REASON_SUB_NOT_NEEDED"),
  [CancelReasonKey.Dissatisfied]: translate("CANCEL_REQ_REASON_DISSATISFIED"),
  [CancelReasonKey.Other]: translate("CANCEL_REQ_REASON_OTHER"),
  [CancelReasonKey.EditRequest]: translate("CANCEL_REQ_REASON_EDIT_REQUEST"),
  [CancelReasonKey.PreferDifferentSub]: translate("CANCEL_REQ_REASON_PREFER_DIFFERENT_SUB"),
  [CancelReasonKey.NotFilledInTime]: translate("CANCEL_REQ_REASON_NOT_FILLED_IN_TIME"),
  [CancelReasonKey.UnhappyWithWaitlist]: translate("CANCEL_REQ_REASON_UNHAPPY_WITH_WAITLIST"),
  // [CancelReasonKey.RovingReassigned]: translate("CANCEL_REQ_REASON_ROVING_REASSIGNED"),
  [CancelReasonKey.RovingUnused]: translate("CANCEL_REQ_REASON_ROVING_UNUSED"),
};

export const unfilledCancelReasons: CancelReasonKeyType[] = [
  CancelReasonKey.EditRequest,
  CancelReasonKey.NotFilledInTime,
  CancelReasonKey.SubNotNeeded,
  CancelReasonKey.SubmitError,
  CancelReasonKey.Other,
];

export const filledCancelReasons: CancelReasonKeyType[] = [
  CancelReasonKey.EditRequest,
  CancelReasonKey.PreferDifferentSub,
  CancelReasonKey.SubNotNeeded,
  CancelReasonKey.SubmitError,
  CancelReasonKey.Other,
];

export const unfilledLTRCancelReasons: CancelReasonKeyType[] = [
  CancelReasonKey.EditRequest,
  CancelReasonKey.NotFilledInTime,
  CancelReasonKey.UnhappyWithWaitlist,
  CancelReasonKey.SubNotNeeded,
  CancelReasonKey.SubmitError,
  CancelReasonKey.Other,
];

export const filledStartedCancelReasons: CancelReasonKeyType[] = [
  CancelReasonKey.EditRequest,
  CancelReasonKey.SubNotNeeded,
  CancelReasonKey.Dissatisfied,
  CancelReasonKey.Other,
];

export const rovingCancelReasons: CancelReasonKeyType[] = [
  // CancelReasonKey.RovingReassigned,
  CancelReasonKey.RovingUnused,
];
